"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GetForegroundColorForColor = require("./GetForegroundColorForColor");
Object.keys(_GetForegroundColorForColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetForegroundColorForColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetForegroundColorForColor[key];
    }
  });
});